import './style.scss';
import psl_actions from '../../libs/psl_actions.js';
import psl_ui from '../../libs/psl_ui.js';
import template from './template.pst';
import state from "../../state.js";
import data from "../../data.js";
import CONFIG from '../../CONFIG.js';

import {wait} from '../../libs/psl_polyfills.js';
import analytics from '../analytics/component.js';

psl_ui.templates.add('menu',template);

const {el,rpoints}=psl_ui.templates.render('menu');
rpoints.link_map.href=CONFIG.url_ama_map||'#';
rpoints.link_website.href=CONFIG.url_ama_website||'#';
rpoints.burger_link_map.href=CONFIG.url_ama_map||'#';
rpoints.burger_link_map.addEventListener('click',()=>{
	analytics.track_menu_click_external('ama map');
});
rpoints.burger_link_website.href=CONFIG.url_ama_website||'#';
rpoints.burger_link_website.addEventListener('click',()=>{
	analytics.track_menu_click_external('ama website');
});
rpoints.menu_logo_img.src=(import.meta.env.BASE_URL||'./')+'img/logos.png';

psl_actions.add('menu.toggle',(e,i)=>{
	analytics.track_menu_click(data.sections[i].name);
	state.section=i;
	el.classList.remove('burger_open');
});

psl_actions.add('menu.burger.toggle',()=>{
	el.classList.toggle('burger_open');
});

psl_actions.add('submenu.toggle',(e,i)=>{
	state.submenu=i;
});

psl_actions.add('submenu.prev',()=>{
	const section=data.sections[state.section];
	const n=section?.submenu?.length||1;
	state.submenu=(state.submenu-1+n)%n;
});

psl_actions.add('submenu.next',()=>{
	const section=data.sections[state.section];
	const n=section?.submenu?.length||1;
	state.submenu=(state.submenu+1)%n;
});

function _render(){
	const menu_items=data.sections.map((section,i)=>(`<li data-action="menu.toggle" data-data=${i}><a>${section.name||""}</a></li>`)).join('');
	rpoints.menu.innerHTML=menu_items;
	rpoints.burger_nav.innerHTML=menu_items;
	_on_toggle();
	if(rpoints.menu_current_label) rpoints.menu_current_label.textContent=data.sections[state.section].name||'';
}

_render();

async function _on_toggle(menu=state.section){
	let section = data.sections[menu];
	const current=rpoints.menu.querySelector('.active');
	if(current) current.classList.remove('active');
	rpoints.menu.childNodes[menu].classList.add('active');
	if(rpoints.menu_current_label) rpoints.menu_current_label.textContent=section.name||'';
	if(el.classList.contains('burger_open')) el.classList.remove('burger_open');

	rpoints.submenu.classList.add('hidden');

	rpoints.options_slider_wrapper.style.setProperty('--submenu-index',0);

	await wait(250);

	if(section.submenu){

		el.classList.remove('submenu_hidden');
		rpoints.submenu.innerHTML=section.submenu.map((submenu,i)=>{
			const name=submenu.name||"";
			const subname=submenu.subname||"";
			return `<li data-action="submenu.toggle" data-data=${i} class="${subname?'two_lines':''}"><a class="hidden">${subname?`<div class="name">${name}</div><div class="subname">${subname}</div>`:name}</li>`}
		).join('');

		rpoints.submenu.classList.remove('hidden');

		await wait(100);

		rpoints.submenu.childNodes.forEach(async (el,i)=>{
			await wait(100*i);
			el.firstChild.classList.remove('hidden');
		})

		_on_sub_toggle();
		_update_carousel_position();
	} else {
		el.classList.add('submenu_hidden');
	}
}

function _update_carousel_position(){
	if(!window.matchMedia('(max-width: 768px)').matches) return;
	const section=data.sections[state.section];
	if(!section?.submenu?.length) return;
	rpoints.options_slider_wrapper.style.setProperty('--submenu-count',section.submenu.length);
	rpoints.options_slider_wrapper.style.setProperty('--submenu-index',state.submenu);
}

function _on_sub_toggle(submenu=state.submenu){
	const current=rpoints.submenu.querySelector('.selected');
	if(current) current.classList.remove('selected');
	rpoints.submenu.childNodes[submenu].classList.add('selected');
	_update_carousel_position();
}

state.events.on('section',_on_toggle);
state.events.on('submenu',_on_sub_toggle);
state.events.on('submenu',()=>{
	analytics.track_submenu_click(data.sections[state.section].submenu[state.submenu].name);
});
state.events.on('data',_render);

rpoints.burger_panel_inner.addEventListener('click',e=>{
	if(e.target===rpoints.burger_panel_inner) e.stopPropagation();
	return;
});
window.addEventListener('resize',()=>{
	if(window.matchMedia('(min-width: 769px)').matches) el.classList.remove('burger_open');
});

document.body.appendChild(el);
